<template>
  <p>{{ label }}</p>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: String,
    label: String,
    required: {
      type: Boolean,
      default: false,
    },
  }
}
</script>
